// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Es15","requiredAsterisk":"Info_requiredAsterisk__DH9Oe"};